import { render, staticRenderFns } from "./MeasuresExportDialog.vue?vue&type=template&id=c8a55f1a&scoped=true"
import script from "./MeasuresExportDialog.vue?vue&type=script&lang=js"
export * from "./MeasuresExportDialog.vue?vue&type=script&lang=js"
import style0 from "./MeasuresExportDialog.vue?vue&type=style&index=0&id=c8a55f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a55f1a",
  null
  
)

export default component.exports